
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'MessageModal',
  props: {
    icon: {
      type: String,
      default: 'info-circle'
    },
    message: {
      type: String,
      required: true
    },
    subMessage: {
      type: String,
      default: '',
      required: false
    },
    buttonText: {
      type: String,
      required: false,
      default: 'OK'
    },
    showButton: {
      type: Boolean,
      default: true
    },
    closeModal: {
      type: Function,
      default: () => {
        /* */
      }
    }
  },

  emits: ['close'],

  methods: {
    close () {
      this.closeModal()
    }
  }
})
